// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__15ucn","row":"Node_row__1lFnN","label":"Node_label__1eQvZ","footer":"Node_footer__1SjnD"};